module.exports = __webpack_public_path__ + "media/honey-icons/icon-signal-1bar-1adce38f.svg";